// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".score-tag.correct,.score-tag.correct i{color:#4caf50!important}.score-tag.incorrect,.score-tag.incorrect i{color:#f44336}.score-tag.ungraded,.score-tag.ungraded i{color:#ef6c01!important}.score-tag.noPoints,.score-tag.noPoints i{color:#2196f3!important}.score-tag{font-size:12px;color:#409eff;border-radius:4px;width:-moz-fit-content;float:left}", ""]);
// Exports
module.exports = exports;
